<!-- Start Content-->
<div class="container-fluid">
    <div class="row my-1">
        <div class="col-md-12">
            <div class="userTables">

                <div class="row">
                    <div class="col-12">
                        <h2>user setting</h2>
                        <tabset class="tabSet" type="pills" *ngIf="data">
                            <tab class="bg-light" heading="{{item?.market_type_id}} ({{data?.event_type_list[item?.event_type_id]}})" *ngFor="let item of data?.user_configs;let i=index;trackBy:trackByIndex;">
    
                                <div class="row justify-content-center">
                                    <div class="col-md-8">
                                        <div class="row admin_form">
                                            <div class="col-md-4 col-6">
                                                <label class="mb-0">Min Bet:</label>
                                                <input type="number" class="form-control" name="min_bet{{i}}"
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="item.min_bet">
                                            </div>
                                            <div class="col-md-4 col-6">
                                                <label class="mb-0">Max Bet:</label>
                                                <input type="number" class="form-control" name="max_bet{{i}}"
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="item.max_bet">
                                            </div>
                                            <div class="col-md-4 col-6">
                                                <label class="mb-0">Max Profit:</label>
                                                <input type="number" class="form-control" name="max_profit{{i}}"
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="item.max_profit">
                                            </div>
                                            <div class="col-md-4 col-6">
                                                <label class="mb-0">Max Market Profit:</label>
                                                <input type="number" class="form-control" name="max_market_profit{{i}}"
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="item.max_market_profit">
                                            </div>
                                            <div class="col-md-4 col-6">
                                                <label class="mb-0">Max Liability:</label>
                                                <input type="number" class="form-control" name="max_liability{{i}}"
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="item.max_liability">
                                            </div>
                                            <div class="col-md-4 col-6">
                                                <label class="mb-0">Max Market Liability:</label>
                                                <input type="number" class="form-control" name="max_market_liability{{i}}"
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="item.max_market_liability">
                                            </div>
                                            <div class="col-md-4 col-6">
                                                <label class="mb-0">Bet Delay:</label>
                                                <input type="number" class="form-control" name="bet_delay{{i}}"
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="item.bet_delay">
                                            </div>
                                            <div class="col-md-4 col-6">
                                                <label class="mb-0">Commission In:</label>
                                                <input type="number" class="form-control" name="commission_in{{i}}"
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="item.commission_in">
                                            </div>
                                            <div class="col-md-4 col-6">
                                                <label class="mb-0">Commission Out:</label>
                                                <input type="number" class="form-control" name="commission_out{{i}}"
                                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="item.commission_out">
                                            </div>
                                            <div class="col-md-12 mt-1">
                                                <div class="btn-group">
                                                    <button class="btn btnSubmit" (click)="onSubmit(item, 'meAndDown')">Update Me And Down-line</button>
                                                    <button class="btn btnCancel" (click)="onSubmit(item, 'me')">Update Only Me</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <app-loader class="full-overlay" *ngIf="submitted"></app-loader>
                            </tab>
                        </tabset>
                        
                        <app-loader class="no-overlay" *ngIf="!data"></app-loader>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>